<template>
  <ModalWrapperComponent dialog-name="ApplyActivationCodeComponent" :show-dialog="showDialog" @close-modal="close">
    <template #header>
      {{ tn("headerH1") }}
    </template>

    <template #content>
      {{ tn("p1") }}
    </template>

    <template #footer>
      <button id="btnCancelDownload" type="button" class="btn-primary" @click="close()">
        {{ tn("continueBtn") }}
      </button>
      <button id="btnClose" type="button" class="inline-btn-link" @click="cancelDownload()">
        {{ tn("closeBtn") }}
      </button>
    </template>
  </ModalWrapperComponent>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { t } from "@/i18n";
import { logEvent } from "@/common/logger";
import ModalWrapperComponent from "@/components/shared/dialogs/ModalWrapper.vue";
import { ICssbDownloadUrlRequest } from "@/components/FileAccess/interfaces";

const componentName = "CSSBCancelDownloadComponent";

export default defineComponent({
  name: componentName,
  components: {
    ModalWrapperComponent,
  },
  props: {
    request: {
      type: Object as PropType<ICssbDownloadUrlRequest>,
      required: true,
    },
    showDialog: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["save-modal", "close-modal"],

  setup(props, context) {
    logEvent("created", componentName, props);

    function tn(v: string, params?: Record<string, unknown>): string {
      return t(`${componentName}.${v}`, params);
    }

    function close() {
      context.emit("close-modal");
    }

    function cancelDownload() {
      context.emit("save-modal", props.request);
    }

    return {
      tn,
      close,
      cancelDownload,
    };
  },
});
</script>
